/*
  PostProcessingForm.jsx
*/

// Npm.
import React from 'react';

// Components.
import CheckboxWithLabel from '../../CheckboxWithLabel';

// Makes.
import { makeStyles } from '../../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  fieldContainer: {
    marginTop: theme.space(1),
  },
}));

// Constants.
const NOOP = () => {};

/**
 * Postprocessing checkboxes.
 */
export default function PostProcessingForm({
  className,
  disabled = false,
  readOnly = false,
  botech,
  onChangeBotech,
}) {

  const classes = useStyles();

  const useBotech = botech || {};
  const postprocessing = useBotech.postprocessing || {};

  const changePostprocessing = readOnly ? NOOP : (fields) => {
    
    // Delete falsey values.
    const next = { ...postprocessing, ...fields };
    for (const [key, value] of Object.entries(next)) {
      if (!value) {
        delete next[key];
      }
    }

    // If all values are false, delete the object.
    const nextBotech = { ...botech };
    if (Object.keys(next).length > 0) {
      nextBotech.postprocessing = next;
    } else {
      delete nextBotech.postprocessing;
    }

    // Call callback.
    if (onChangeBotech) {
      onChangeBotech(nextBotech);
    }
  };

  function handleChangeReciprocal(event) {
    changePostprocessing({ reciprocal: event.target.checked });
  }

  function handleChangeInverse(event) {
    changePostprocessing({ inverse: event.target.checked });
  }

  return (
    <>
      <div className={classes.fieldContainer}>
        <CheckboxWithLabel
          label="Reciprocal"
          fullWidth
          checked={postprocessing.reciprocal === true}
          onChange={handleChangeReciprocal}
          disabled={disabled}
          readOnly={readOnly}
        />
      </div>
      <div className={classes.fieldContainer}>
        <CheckboxWithLabel
          label="Inverse"
          fullWidth
          checked={postprocessing.inverse === true}
          onChange={handleChangeInverse}
          disabled={disabled}
          readOnly={readOnly}
        />
      </div>
    </>
  );
}
